<div class="property-summary-page">
    <tg-row>
        <tg-col>
            <h1>Your listing summary</h1>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col>
            <p>You’re almost ready to go! Here’s a summary of your listing.</p>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-property-information-section></property-summary-page-property-information-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-sale-details-section></property-summary-page-sale-details-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-property-description-section></property-summary-page-property-description-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
      <tg-col lg="6" sm="12">
        <div
          class="
                      property-summary-page__section
                      property-summary-page__section--ruled
                  "
        >
          <property-summary-page-contact-details-section></property-summary-page-contact-details-section>
        </div>
      </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-open-homes-section></property-summary-page-open-homes-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-photos-media-section></property-summary-page-photos-media-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-promotions-section></property-summary-page-promotions-section>
            </div>
        </tg-col>
    </tg-row>
    <tg-row>
        <tg-col lg="6" sm="12">
            <div
                class="
                    property-summary-page__section
                    property-summary-page__section--last
                    property-summary-page__section--ruled
                "
            >
                <property-summary-page-summary-section></property-summary-page-summary-section>
            </div>
        </tg-col>
    </tg-row>
</div>
<property-summary-page-validation-summary-section></property-summary-page-validation-summary-section>
